import axios from 'axios';

export class AiCoreTextEditorService
{
    private static getUrl()
    {
        const config = useRuntimeConfig();

        return config.public.localApiUrl;
    }

    private static getAuthHeader()
    {
        const { $auth } = useAuth();

        return { Authorization: `Bearer ${$auth.token()}` };
    }

    public static async getTextEditor(params: {
        provider: string;
        owner: string;
        name: string;
    }, payload: TextEditorPayload)
    {
        return (await axios.post<TextEditorResponse>(`${this.getUrl()}/aicore/text-editor`, payload, { params, headers: this.getAuthHeader() })).data;
    }

    public static async getTextEditorPromise(params: {
        provider: string;
        owner: string;
        name: string;
    }, payload: TextEditorPayload)
    {
        return (await axios.post<TextEditorResponse>(`${this.getUrl()}/aicore/text-editor`, payload, { params, headers: this.getAuthHeader() }));
    }
}

export default AiCoreTextEditorService;

// export enum TextEditorTools
// {
//     TextGeneration = 'TextGeneration',
//     Translation = 'Translation',
//     CustomPrompt = 'CustomPrompt',
//     TextExpand = 'TextExpand',
//     TextChange = 'TextChange',
//     TextTone = 'TextTone',
//     TextCorrection = 'TextCorrection',
//     Summarization = 'Summarization',
//     GrammarCheck = 'GrammarCheck'
// };

// export type TextEditorPayload = TextGenerationTool
//     | CustomPromptTool
//     | TranslationTool
//     | TextChangeTool
//     | TextToneTool
//     | TextExpandTool
//     | TextCorrectionTool
//     | TextChangeTool
//     | SummarizationTool
//     | GrammarCheckTool;

// export interface TextGenerationTool
// {
//     Tool: TextEditorTools.TextGeneration;
//     TextGeneration: {
//         Prompt: string;
//     };
// }

// export interface CustomPromptTool
// {
//     Tool: TextEditorTools.CustomPrompt;
//     CustomPrompt: {
//         Text: string;
//         Prompt: string;
//     };
// }

// export interface TranslationTool
// {
//     Tool: TextEditorTools.Translation;
//     Translation: {
//         Text: string;
//         Language: string;
//     };
// }

// export interface TextChangeTool
// {
//     Tool: TextEditorTools.TextChange;
//     TextChange: {
//         Text: string;
//         Style: string;
//     };
// }

// export interface TextToneTool
// {
//     Tool: TextEditorTools.TextTone;
//     TextTone: {
//         Text: string;
//         Tone: string;
//     };
// }

// export interface TextExpandTool
// {
//     Tool: TextEditorTools.TextExpand;
//     TextExpand: {
//         Text: string;
//     };
// }

// export interface GrammarCheckTool
// {
//     Tool: TextEditorTools.GrammarCheck;
//     GrammarCheck: {
//         Text: string;
//     };
// }

// export interface TextCorrectionTool
// {
//     Tool: TextEditorTools.TextCorrection;
//     TextCorrection: {
//         Text: string;
//     };
// }

// export interface SummarizationTool
// {
//     Tool: TextEditorTools.Summarization;
//     Summarization: {
//         Text: string;
//     };
// }

// export interface TextEditorResponse
// {
//     message: string;
// }
